import { CompanyEntity } from '../common/entity';

export class ProductTransactionStatus extends CompanyEntity {
  name!: string;
  color!: string;

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
  }
}
